import React from 'react';
import './MainWIndow.scss';
import { Outlet } from 'react-router-dom';

const MainWindow = () => {
  return (
    <div className='MainWindow'>
      <Outlet />
    </div>
  );
};

export default MainWindow;
